import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

const FilterForm = ({
  formData,
  handleChange,
  handleDropDownChange,
  handleSubmit,
  jobtitleopts,
  statusopts,
  hropts,
  sourceopts,
  handleReset,
  skillsopts,
}) => {
  const stopPropagation = (event) => {
    event.stopPropagation();
  };
  return (
    <div className="container">
      <div className="row">
        <form onClick={stopPropagation}>
          <div className="row">
            <div className="col-4">
              <Form.Group className="row">
                <Form.Label className="mb-0">Job Title</Form.Label>
                <Select
                  options={[
                    { value: null, label: "Select..." },
                    ...jobtitleopts,
                  ]}
                  name="jobTitle"
                  placehoder="JOB Titles"
                  value={formData.jobTitle}
                  onChange={(selected) =>
                    handleDropDownChange(selected, "jobTitle")
                  }
                />
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group className="row">
                <div className="col-4">
                  <Form.Label className="mb-0">Status</Form.Label>
                </div>
                <Select
                  options={[{ value: null, label: "Select..." }, ...statusopts]}
                  name="status"
                  value={formData.status}
                  onChange={(selected) =>
                    handleDropDownChange(selected, "status")
                  }
                />
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group className="row">
                  <Form.Label className="mb-0">HR Name</Form.Label>
                <Select
                  options={[{ value: null, label: "Select..." }, ...hropts]}
                  name="hrName"
                  value={formData.hrName}
                  onChange={(selected) =>
                    handleDropDownChange(selected, "hrName")
                  }
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-4 mt-2">
              <Form.Group>
                <div>
                  <Form.Label className="mb-0">Candidate Name</Form.Label>
                </div>
                <Form.Control
                  type="text"
                  name="candidateName"
                  value={formData.candidateName}
                  onChange={(e) => handleChange(e)}
                ></Form.Control>
              </Form.Group>
            </div>

            <div className="col-sm-4">
              <label className="form-label">Source</label>

              <Select
                options={[{ value: null, label: "Select..." }, ...sourceopts]}
                name="source"
                value={formData.source}
                onChange={(selected) =>
                  handleDropDownChange(selected, "source")
                }
              />
            </div>

            <div className="col-sm-4">
              <label className="form-label">Skills</label>

              <Select
                options={[{ value: null, label: "Select..." }, ...skillsopts]}
                name="skill"
                value={formData.skill}
                onChange={(selected) => handleDropDownChange(selected, "skill")}
              />
            </div>
          </div>


          <div className="row mt-4">
             <div className="text-end gap-2">
             <button
  className="custom-btn me-2"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    handleReset();
  }}
  type="button"
>
  Reset
</button>
            <button
              className="custom-btn"
              onClick={async (e) => {
                e.preventDefault();
                await handleSubmit();
              }}
              type="button"
              // onMouseDown={(e) => e.preventDefault()}
            >
              Get data
            </button>
          </div>
        </div>
        </form>

      </div>
    </div>
  );
};

export default FilterForm;
